<template>
	<view class="container login-page">
		<view class="uni-common-mt">
			<form @submit="loginPassword">
				<view class="uni-form-item uni-column">
					<input class="uni-input" name="username" placeholder="用户名/邮箱/已验证手机" />
				</view>
				<view class="uni-form-item uni-column mart10">
					<input class="uni-input" name="password" password="true" placeholder="请输入密码"/>
				</view>
				<view class="uni-btn-v mart10">
					<button form-type="submit" type="warn">登录</button>
				</view>
			</form>
		</view>
		<view class="center mart10">
			<navigator src="/pages/user/register" class="a_blue inline marr10">免费注册</navigator>
			<text class="gray marr10">|</text>
			<navigator src="/pages/user/getpass" class="inline a_blue">忘记密码</navigator>
		</view>
		<view class="fast-login" @tap="loginWx">
			<uni-icons type="weixin" color="#4DAF29" size="40" />
			<view class="login-text">微信登录</view>
		</view>
	</view>
</template>

<script>
	import uniNavBar from "@/components/uni-nav-bar/uni-nav-bar.vue"
	const app = getApp();
	export default {
		data() {
			return {
				
			}
		},
		components: {uniNavBar},
		onShow: function (option) {
			var that = this;
			var unitag = uni.getStorageSync('unitag');
			if (unitag) {
				app.getApi('POST', 'base/login', {type: 'unitag', unitag: unitag}, 0, function (data) {
					that.loginOk(data);
				});
			}
		},
		methods: {
			loginPassword: function(e){
				var that = this;
				var data = e.detail.value;
				var checks = ['username', 'password'];
				for(var i in checks)
				{
					var val = data[checks[i]].trim();
					switch(checks[i])
					{
						case 'username':
							if(val == ''){
								app.toast('请输入账号');
								return false;
							}else if(val.length < 4){
								app.toast('此账号不存在');
								return false;
							} 
						break;
						case 'password':
							if(val == ''){
								app.toast('请输入密码');
								return false;
							}else if (val.length < 6 || val.length > 20){
								app.toast('密码错误');
								return false;
							}
						break;
					}
				}
				
				app.getApi('POST', 'base/login', {type: 'password', username: data.username, password: data.password}, 1, function (data) {
					that.loginOk(data);
				});
			},
			loginWx: function(){
				var that = this;
				uni.login({
					provider:'weixin',
					success: (res) => {
						//console.log(res);
						app.getApi('GET', 'data/getWxUserByCode', {app: app.globalData.wxAppKey, code:res.code }, 1, function (data) {
							app.getApi('POST', 'base/login', {type: 'weixin', unionid: data.unionid}, 1, function (data) {
								that.loginOk(data);
							});
						});
					},
					fail: (err) => {
						app.toast('授权登录失败，请稍后重试。');
					}
				});
			},
			loginOk:function(userData){
				app.globalData.userInfo = userData;
				uni.setStorage('unitag', userData.unitag);
				uni.navigateBack();
			},
			back:function(){
				uni.switchTab({ url: '/pages/index/index' });
			}
		}
	}
</script>

<style>
	page{background-color: #fff;}
	.login-page{padding: 20px 15px;}
	
    .uni-input {
        border-bottom: 1px solid #eee;
    }
	.fast-login{text-align: center;margin-top:20%;border-top: 1px solid #eee ;}
	.fast-login .login-text{display: block;margin-top: -20px;}
</style>
